import joinClasses from "helpers/joinClasses";

export const SubTitle = ({ children, className, ...props }) => {
  return (
    <h1
      className={joinClasses(
        "text-[25px] font-semibold monterrat-font text-black-ligth",
        className
      )}
      {...props}
    >
      {children}
    </h1>
  );
};
